export var TooltipPositions;
(function (TooltipPositions) {
    TooltipPositions["top"] = "top";
    TooltipPositions["down"] = "down";
    TooltipPositions["left"] = "left";
    TooltipPositions["right"] = "right";
})(TooltipPositions || (TooltipPositions = {}));
export var TooltipAlign;
(function (TooltipAlign) {
    TooltipAlign["middle"] = "middle";
    TooltipAlign["left"] = "left";
    TooltipAlign["right"] = "right";
})(TooltipAlign || (TooltipAlign = {}));
//# sourceMappingURL=constants.js.map